import * as React from "react";
import WidgetContentSkeleton from "views/components/widgets/WidgetContentSkeleton";
const LoadingWidget = ({ visualization = void 0 }) => /* @__PURE__ */ React.createElement(WidgetContentSkeleton, { visualization });
export default LoadingWidget;
